import { AudioContext } from '@rhg/providers/audio';
import { useContext } from 'react';

export function useAudio() {
    return useContext(AudioContext);
}
